<div class="field">
  <span class="field-title"
    >Tipo de propuesta<span class="asterisk">*</span></span
  >
  <select-input
    class="input"
    [placeHolder]="'Tipo de propuesta'"
    [value]="getProposalTypeSelected()"
    [OBJECT]="proposalTypes"
    [doFilterObject]="false"
    [array]="arrayProposalTypes"
    (valueOut)="setValueWithEvent($event)"
  ></select-input>
</div>
